export default "__VITE_ASSET__8530a2c2__"